var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header f-c-e"},[_c('div',{staticClass:"infoBox f-c-c"},[_c('img',{staticClass:"avatarUrl",attrs:{"src":_vm.AvatarUrl,"alt":"AvatarUrl"}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.Name))]),_c('div',{staticClass:"outBtn",on:{"click":_vm.signOut}},[_vm._v("退出登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }